module.exports = __webpack_public_path__ + "static/img/2.c5e15985.png";